/** Sentinel: leere Filter-Ansicht (Gegenteil zu „alle“ = []). */
export const FILTER_MULTI_SELECT_NONE = '__filter_multi_select_none__';

/** @deprecated Nutze FILTER_MULTI_SELECT_NONE */
export const EMPLOYEE_MULTI_SELECT_NONE = FILTER_MULTI_SELECT_NONE;

export function isFilterMultiSelectNone(selected: string[]): boolean {
  return selected.length === 1 && selected[0] === FILTER_MULTI_SELECT_NONE;
}

/** @deprecated Nutze isFilterMultiSelectNone */
export const isEmployeeMultiSelectNone = isFilterMultiSelectNone;

export function isFilterMultiSelectAll(selected: string[], optionCount: number): boolean {
  if (isFilterMultiSelectNone(selected)) return false;
  return selected.length === 0 || (optionCount > 0 && selected.length >= optionCount);
}

/** @deprecated Nutze isFilterMultiSelectAll */
export const isEmployeeMultiSelectAll = isFilterMultiSelectAll;
